/* A cart offer is only shown when a single, undiscounted kit can be replaced safely. */
(function(root) {
  'use strict';
  function eligibleUpgrade(cart, offer, currency) {
    if (!offer?.available || !cart || cart.currency !== currency) return null;
    if (![offer.from, offer.to, offer.productId, offer.fromPrice, offer.toPrice].every(Number.isSafeInteger)) return null;
    if (offer.from === offer.to || offer.fromPrice <= 0 || offer.toPrice <= offer.fromPrice) return null;
    if (cart.cart_level_discount_applications?.length || cart.total_discount > 0) return null;
    const kits = cart.items.filter(item => Number(item.product_id) === offer.productId);
    if (kits.length !== 1) return null;
    const item = kits[0];
    if (Number(item.variant_id) !== offer.from || item.quantity !== 1 || item.selling_plan_allocation) return null;
    if (Object.keys(item.properties || {}).length || item.line_level_discount_allocations?.length) return null;
    if (item.final_price !== offer.fromPrice || item.original_price !== offer.fromPrice) return null;
    return { key: item.key, to: offer.to, difference: offer.toPrice - item.final_price };
  }
  function findUpgrade(cart, offers, currency, productId) {
    const candidates = Array.isArray(offers) ? offers : [];
    const ordered = (cart?.items || []).map(item => candidates.find(offer => offer.productId === Number(item.product_id))).filter(Boolean);
    for (const offer of ordered) {
      if (productId != null && Number(productId) !== offer.productId) continue;
      const upgrade = eligibleUpgrade(cart, offer, currency);
      if (upgrade) return { ...upgrade, offer };
    }
    return null;
  }
  const api = Object.freeze({ eligibleUpgrade, findUpgrade });
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.HwOffers = api;
})(typeof window === 'undefined' ? {} : window);
